export default "__VITE_ASSET__CxxtZ8xM__"